import { render, staticRenderFns } from "./DescriptionEntityType.vue?vue&type=template&id=06b30c79&scoped=true"
import script from "./DescriptionEntityType.vue?vue&type=script&lang=js"
export * from "./DescriptionEntityType.vue?vue&type=script&lang=js"
import style0 from "./DescriptionEntityType.vue?vue&type=style&index=0&id=06b30c79&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b30c79",
  null
  
)

export default component.exports